export default function PageBackdrop() {
  return (
    <>
      <div className="page-backdrop" aria-hidden="true">
        <div className="page-grid"></div>
        <div className="page-orb page-orb-one"></div>
        <div className="page-orb page-orb-two"></div>
        <div className="page-orb page-orb-three"></div>
      </div>
      <div className="grain" aria-hidden="true"></div>
    </>
  );
}
